import React, { useState } from 'react'
import VideoModal from './VideoModal';

const Brochure = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  
  return (
    <>
      <div className='flex flex-col items-center space-y-6 text-[#1b1b1b] py-12 bg-[#fafafa]'>
        <h1 className='text-[22px] md:text-[32px] font-semibold'>Tour Leafwell Farm</h1>
        <p className='w-full lg:w-[60%] px-6 md:px-0 text-[16px] md:text-[22px] text-center'>Learn more about living at Leafwell Farm. A dedicated property for living in nature while remaining connected to fast pace cities at your own leisure. We are excited to welcome you!</p>
        <div onClick={openModal} >
          <button className='bg-[#1b1b1b] text-white rounded-full px-10 md:px-16 py-3.5 md:py-4 text-[14px] md:text-[18px] font-medium mt-4 md:mt-6 lg:mt-12'>Tour Leafwell Farm</button>
        </div>
      </div>

      <VideoModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  )
}

export default Brochure